export var DocQueryParams;
(function (DocQueryParams) {
    DocQueryParams["DriveId"] = "drive";
    DocQueryParams["ItemId"] = "item";
    DocQueryParams["DocUrl"] = "file";
    DocQueryParams["ContentUri"] = "contenturi";
    DocQueryParams["Nav"] = "nav";
})(DocQueryParams || (DocQueryParams = {}));
//# sourceMappingURL=DocQueryParams.js.map